module.exports = __webpack_public_path__ + "static/media/18ECA18.e1647294.jpg";